'use client'

import { Button } from 'react-aria-components'
import { useClearRefinements } from 'react-instantsearch'
import { useSetAtom } from 'jotai'

import { startDateAtom } from '@/components/filters/state'

const beforeGradient = `
  before:absolute
  before:top-[-31px]
  before:block
  before:w-full
  before:h-[30px]
  before:content-['']
  before:bg-gradient-to-t
  before:from-white
  before:to-transparent
`

export default function FilterModalFooter() {
  const { refine: clearRefinements } = useClearRefinements()
  const setStartDate = useSetAtom(startDateAtom)

  return (
    <footer
      className={`sticky bottom-0 left-0 z-10 border-t border-grey-300 bg-white px-l py-m m:px-m s:py-xs ${beforeGradient}`}>
      <div className="flex items-center justify-between">
        <button
          onClick={() => {
            setStartDate(null)
            clearRefinements()
          }}
          className="cursor-pointer text-17 font-bold text-black transition-colors hover:text-primary ms:text-14">
          Clear
        </button>

        <Button slot="close" className="btn btn--solid btn--small ms:min-h-0 ms:p-xs ms:text-14">
          Show Results
        </Button>
      </div>
    </footer>
  )
}
